var map = {
	"./asteroids.png": 141,
	"./battleship.png": 142,
	"./contra.png": 143,
	"./diablo.png": 144,
	"./everquest.png": 145,
	"./fable.png": 146,
	"./venuemap.png": 33
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41;


//////////////////
// WEBPACK FOOTER
// ./src/components/images ^\.\/.*\.png$
// module id = 41
// module chunks = 0